export default ({ request }) => ({
  baseUserListApi(data = {}) {
    return request({
      url: '/digitalCenter/baseUser/getBaseUserlist',
      method: 'post',
      data,
    })
  },
  baseUserTransferDataApi() {
    return request({
      url: '/digitalCenter/baseUser/transfer/list',
      method: 'post',
    })
  },
  baseUserGroupListApi(data = {}) {
    return request({
      url: '/digitalCenter/base/user/group/list',
      method: 'post',
      data,
    })
  },
  baseUserGroupSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/base/user/group/save',
      method: 'post',
      data,
    })
  },
  baseUserGroupDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/base/user/group/detail',
      method: 'post',
      data,
    })
  },
  baseUserGroupDelApi(data = {}) {
    return request({
      url: '/digitalCenter/base/user/group/del',
      method: 'post',
      data,
    })
  },
})
